export default "__VITE_ASSET__DOccQpB2__"